/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AttemptsInputs */

const en__field_attempts = /** @type {(inputs: _Field_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attempts`)
};

/**
* | output |
* | --- |
* | "Attempts" |
*
* @param {_Field_AttemptsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const _field_attempts = /** @type {((inputs?: _Field_AttemptsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AttemptsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_attempts(inputs)
});